
export function mapTabs(tabstr: string, arr: string[], tabCount: number): string[] {
    const tabs = tabstr.repeat(tabCount);
    return Array.from(arr).map(a => tabs + a);
}

export function joinLines(linestr: string, arr: string[]): string {
    return Array.from(arr).join(linestr)
}